<template>
  <v-simple-table
    height="300px"
    dense>
    <template v-slot:default>
      <tbody>
      <tr
        v-for="(item, index) in values"
        :key="index"
      >
        <td v-if="!showLink">{{ item.key }}</td>
        <td v-else>
          <a :href="'/iot/elevator?resourceId=' + item.id" target="_blank"> {{ item.key }} </a>
        </td>
        <td> {{ item.value }} </td>
      </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>

import ElevatorService from "@/modules/display/services/elevator-service";
import Utils from '@/modules/core/services/utils';

export default {
  name: "DashboardCard",
  props: {
    link: String,
    cardType: String,
    showLink: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      values: []
    }
  },

  created() {
    ElevatorService.getDashboardData(
      this.link,
      (response) => {
        this.values = response.data;
      },
      () => {
        Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.cardType}));
      }
    )
  }
}
</script>